import Vue from 'vue'
import Buefy from 'buefy'

import { detectIE } from './utils'
import App from './App.vue'
import router from './router'
import store from './store'
//import VueAnalytics from 'vue-analytics';

//const GA_ID = process.env.GA_ID

Vue.use(Buefy)

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  let isIE = detectIE()
  if (isIE === false || to.name == 'update-browser') {
    next()
  } else {
    next({name: 'update-browser'})
  }
})

// Configuration VueAnalytics
//Vue.use(VueAnalytics, {
//  id: GA_ID,
//  router
//});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
